import Main from '@/views/Main.vue'
export const loginRouter = {
    path: '/login',
    name: 'login',
    meta: {
        title: 'Login - 登录',
        requireAuth: true
    },
    component: () =>
        import('@/views/login.vue'),
    alias: '/'
}
export const loginJump = {
    path: '/loginJump',
    meta: {
        title: '登录跳转'
    },
    name: 'loginJump',
    component: () =>
        import('@/views/errorpage/loginJump.vue')
}
export const page403 = {
    path: '/403',
    meta: {
        title: '403-权限不足',
        requireAuth: true
    },
    name: 'error-403',
    component: () =>
        import('@/views/errorpage/403.vue')
}

export const page404 = {
    path: '/404',
    meta: {
        title: '404-页面不存在或已被删除'
    },
    name: 'error-404',
    component: () =>
        import('@/views/errorpage/404.vue')
}
export const page500 = {
    path: '/500',
    meta: {
        title: '500-服务端错误'
    },
    name: 'error-500',
    component: () =>
        import('@/views/errorpage/500.vue')
}
// 作为Main组件的子页面展示并且在菜单显示的路由写在appRouter里
export const appRouter = [{
    path: '/home',
    name: 'home',
    title: '首页',
    component: Main,
    children: [{
        path: 'index',
        title: '首页',
        name: 'index',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/home/index.vue')
    }]
},
{
    path: '/system',
    name: 'system',
    title: '用户管理',
    component: Main,
    children: [{
        path: 'userlist',
        title: '人员列表',
        name: 'userlist',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/employee/userlist.vue')
    },
    // 收货方
    {
        path: 'receiverTypeManagement',
        title: '收货方类型管理',
        name: 'receiverTypeManagement',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/receiver/receiverTypeList.vue')
    },
    // 权限管理
    {
        path: 'roleList',
        title: '角色管理',
        name: 'roleList',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/permissions/roleList.vue')
    },
    {
        path: 'productGroupList',
        title: '产品权限组管理',
        name: 'productGroupList',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/permissions/productGroupList.vue')
    },
    {
        path: 'approvalTree',
        title: '审批节点管理',
        name: 'approvalTree',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/permissions/approvalTree.vue')
    },
    // 字典管理
    {
        path: 'dictionaryAdministration',
        title: '字典管理',
        name: 'dictionaryAdministration',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/dictionaries/dictionaryAdministration.vue')
    },
    // 工作日
    {
        path: 'workdaymaintenance',
        title: '工作日管理',
        name: 'workdaymaintenance',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/cycleManagement/workdaymaintenance.vue')
    },
    // 流向设置
    {
        path: 'replyRadixSetting',
        title: '反馈基数设置',
        name: 'replyRadixSetting',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/saleFlowSetting/replyRadixSetting.vue')
    },
    // 流向设置
    {
        path: 'replyRateLineSetting',
        title: '退货率基线设置',
        name: 'replyRateLineSetting',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/saleFlowSetting/replyRateLineSetting.vue')
    },
    // 流向设置
    {
        path: 'productSettingOfSuspect',
        title: '疑似调拨品种设置',
        name: 'productSettingOfSuspect',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/saleFlowSetting/productSettingOfSuspect.vue')
    },
    {
        path: 'baselineSettingOfTargetHospital',
        title: '目标医院销量基线',
        name: 'baselineSettingOfTargetHospital',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/saleFlowSetting/baselineSettingOfTargetHospital.vue')
    },
    // 周期管理
    {
        path: 'cycleManagement',
        title: '周期管理',
        name: 'cycleManagement',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/cycleManagement/cycleManagement.vue')
    },
    // 自动服务运行状态查询
    {
        path: 'taskStatus',
        title: '自动服务运行状态查询',
        name: 'taskStatus',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/cycleManagement/taskStatus.vue')
    },
    // 进销存设置
    {
        path: 'safetyStockRange',
        title: '安全库存范围设置',
        name: 'safetyStockRange',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/inventorySetting/safetyStockRange.vue')
    },
    {
        path: 'inventoryReportSetup',
        title: '库存报表设置',
        name: 'inventoryReportSetup',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/inventorySetting/inventoryReportSetup.vue')
    },
    {
        path: 'baselineOfInventoryCheckDate',
        title: '日库存差异反馈基线',
        name: 'baselineOfInventoryCheckDate',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/inventorySetting/baselineOfInventoryCheckDate.vue')
    },
    {
        path: 'discrepancyRateOfInventoryDaily',
        title: '日库存差异率设置',
        name: 'discrepancyRateOfInventoryDaily',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/inventorySetting/discrepancyRateOfInventoryDaily.vue')
    },
    {
        path: 'inventoryEstimateSetting',
        title: '经销商库存预估设置',
        name: 'inventoryEstimateSetting',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/inventorySetting/inventoryEstimateSetting.vue')
    },
    {
        path: 'exceptionLogQuery',
        title: '异常日志管理',
        name: 'exceptionLogQuery',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/logManagement/exceptionLogQuery.vue')
    },
    {
        path: 'eventLogQuery',
        title: '事件日志管理',
        name: 'eventLogQuery',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/logManagement/eventLogQuery.vue')
    },
    {
        path: 'documentList',
        title: '常用文档设置',
        name: 'documentList',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/download/documentList.vue')
    },
    {
        path: 'loginLogQuery',
        title: '登录日志管理',
        name: 'loginLogQuery',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/logManagement/loginLogQuery.vue')
    },
    {
        path: 'materialOrderSetting',
        title: '物料下单设置',
        name: 'materialOrderSetting',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/orderSetting/materialOrderSetting.vue')
    },
    {
        path: 'contractSetting',
        title: '合同页脚设置',
        name: 'contractSetting',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/orderSetting/contractSetting.vue')
    },
    {
        path: 'announcementQuery',
        title: '公告维护',
        name: 'announcementQuery',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/user/announcementQuery.vue')
    },
    // 首页设置
    {
        path: 'DDIContributionRateSetting',
        title: 'DDI商业TMS贡献率',
        name: 'DDIContributionRateSetting',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/homeSettings/DDIContributionRateSetting.vue')
    },
    {
        path: 'otherShipperSettings',
        title: '其他货主设置',
        name: 'otherShipperSettings',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/homeSettings/otherShipperSettings.vue')
    },
    {
        path: 'notificationSetting',
        title: '通知忽略设置',
        name: 'notificationSetting',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/homeSettings/notificationSetting.vue')
    },
    {
        path: 'noticeDefaultNumberSetting',
        title: '公告默认条数设置',
        name: 'noticeDefaultNumberSetting',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/homeSettings/noticeDefaultNumberSetting.vue')
    },
    {
        path: 'weChatNoticeSettings',
        title: '云商通知设置',
        name: 'weChatNoticeSettings',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/weChatSettings/weChatNoticeSettings.vue')
    },
    {
        path: 'customerManagement',
        title: '客户管理',
        name: 'customerManagement',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/weChatSettings/customerManagement.vue')
    },
    {
        path: 'customerNoticeManagement',
        title: '客户管理',
        name: 'customerNoticeManagement',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/weChatSettings/customerNoticeManagement.vue')
    }
    ]
},
{
    path: '/master',
    name: 'master',
    title: '产品主数据',
    component: Main,
    children: [{
        path: 'product',
        title: '产品基本信息',
        name: 'product',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/master/product/product.vue')
    },
    {
        path: 'productlevel',
        title: '产品组管理',
        name: 'productlevel',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/master/product/productlevel.vue')
    },
    {
        path: 'productanother',
        title: '产品别名',
        name: 'productanother',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/master/product/productanother.vue')
    },
    {
        path: 'batchimport',
        title: '批号导入',
        name: 'batchimport',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/master/product/batchimport.vue')
    },
    {
        path: 'batchlist',
        title: '产品批号',
        name: 'batchlist',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/master/product/batchlist.vue')
    },
    {
        path: 'batchanother',
        title: '批号别名',
        name: 'batchanother',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/master/product/batchanother.vue')
    },
    {
        path: 'materialGroup',
        title: '分型查询',
        name: 'materialGroup',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/master/product/materialGroupList.vue')
    },
    {
        path: 'allmateriallist',
        title: '全部物料',
        name: 'allmateriallist',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/master/product/allmateriallist.vue')
    },
    // 流向商业管理
    {
        path: 'distributorList',
        title: '流向商业管理',
        name: 'distributorList',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/master/distributorList/distributorList.vue')
    },
    {
        path: 'myApproval',
        title: '审批记录',
        name: 'myApproval',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/master/distributorList/myApproval.vue')
    },
    {
        path: 'applyList',
        title: '我的申请',
        name: 'applyList',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/master/distributorList/applyList.vue')
    },
    {
        path: 'confirmList',
        title: '我的待办',
        name: 'confirmList',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/master/distributorList/confirmList.vue')
    },
    {
        path: 'contractorList',
        title: '联系人管理',
        name: 'contractorList',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/master/distributorList/contractorList.vue')
    },
    {
        path: 'productChannelList',
        title: '渠道管理',
        name: 'productChannelList',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/master/distributorList/productChannelList.vue')
    },
    {
        path: 'distributorProductQuery',
        title: '流向商业产品信息',
        name: 'distributorProductQuery',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/master/distributorList/distributorProductQuery.vue')
    },
    // 打单商业查询
    {
        path: 'distributorProductQueryByBO',
        title: '打单商业查询',
        name: 'distributorProductQueryByBO',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/master/distributorList/distributorProductQueryByBO.vue')
    },
    {
        path: 'historyBillQuery',
        title: '历史单据查询',
        name: 'historyBillQuery',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/master/distributorList/historyBillQuery.vue')
    },
    {
        path: 'gXPBusinessInformationImport',
        title: 'GXP商业信息导入',
        name: 'gXPBusinessInformationImport',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/master/distributorList/gXPBusinessInformationImport.vue')
    },
    // 收货方
    {
        path: 'receiverList',
        title: '收货方管理',
        name: 'receiverList',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/master/receiver/receiverList.vue')
    },
    {
        path: 'receiverAliasList',
        title: '收货方别名管理',
        name: 'receiverAliasList',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/master/receiver/receiverAliasList.vue')
    },
    {
        path: 'drugstoreNearHospitalManagement',
        title: '院边店管理',
        name: 'drugstoreNearHospitalManagement',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/master/receiver/drugstoreNearHospitalManagement.vue')
    },
    {
        path: 'queryVolumeOfTargetHospital',
        title: '目标医院指标查询',
        name: 'queryVolumeOfTargetHospital',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/master/receiver/queryVolumeOfTargetHospital.vue')
    },
    {
        path: 'receiverLog',
        title: '收货方日志',
        name: 'receiverLog',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/master/receiver/receiverLog.vue')
    },
    {
        path: 'hcoGapReport',
        title: '收货方差异报表',
        name: 'hcoGapReport',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/master/receiver/hcoGapReport.vue')
    },
    {
        path: 'receiverAliasChangeRequestList',
        title: '别名变更申请',
        name: 'receiverAliasChangeRequestList',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/master/receiver/receiverAliasChangeRequestList.vue')
    },
    // 地理信息管理
    {
        path: 'areaList',
        title: '大区管理',
        name: 'areaList',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/master/geography/areaList.vue')
    },
    {
        path: 'cityList',
        title: '城市管理',
        name: 'cityList',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/master/geography/cityList.vue')
    },
    {
        path: 'countyList',
        title: '区县管理',
        name: 'countyList',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/master/geography/countyList.vue')
    }
    ]
}, {
    path: '/salesFlow',
    name: 'salesFlow',
    title: '流向管理',
    component: Main,
    children: [
        // 数据导入
        {
            path: 'DDIImport',
            title: 'DDI数据导入',
            name: 'DDIImport',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/dataImport/DDIImport.vue')
        },
        {
            path: 'standardTemplateUpload',
            title: '标准模板上传',
            name: 'standardTemplateUpload',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/dataImport/standardTemplateUpload.vue')
        },
        {
            path: 'monthlySAPData',
            title: 'SAP月数据生成',
            name: 'monthlySAPData',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/dataImport/monthlySAPData.vue')
        },
        {
            path: 'manualUploadLog',
            title: '上传日志列表',
            name: 'manualUploadLog',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/dataImport/manualUploadLog.vue')
        },
        {
            path: 'autoUploadLog',
            title: '自动日志列表',
            name: 'autoUploadLog',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/dataImport/autoUploadLog.vue')
        },
        // 流向数据确认
        {
            path: 'distributorSalesFlowConfirm',
            title: '流向商业流向确认',
            name: 'distributorSalesFlowConfirm',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/salesFlowConfirm/distributorSalesFlowConfirm.vue')
        },
        {
            path: 'preparatorySalesFlowConfirm',
            title: '可追溯商业流向确认',
            name: 'preparatorySalesFlowConfirm',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/salesFlowConfirm/preparatorySalesFlowConfirm.vue')
        },
        // 采购数据查询
        {
            path: 'monthlyPurchaseQuery',
            title: '月采购数据',
            name: 'monthlyPurchaseQuery',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/otherQuery/monthlyPurchaseQuery.vue')
        },
        // 异常终端报表
        {
            path: 'abnormalTerminalReport',
            title: '异常终端报表',
            name: 'abnormalTerminalReport',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/otherQuery/abnormalTerminalReport.vue')
        },
        // 三方购进报表
        {
            path: 'thirdPartyProcurementReport',
            title: '三方购进报表',
            name: 'thirdPartyProcurementReport',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/otherQuery/thirdPartyProcurementReport.vue')
        },
        {
            path: 'dailyPurchaseQuery',
            title: '日采购数据',
            name: 'dailyPurchaseQuery',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/otherQuery/dailyPurchaseQuery.vue')
        },
        // 月流向数据查询
        {
            path: 'salesFlowDetailQuery',
            title: '流向商业流向查询',
            name: 'salesFlowDetailQuery',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/salesFlowQuery/salesFlowDetailQuery.vue')
        },
        // 月流向数据查询
        {
            path: 'distributorSalesFlowSimpleQuery',
            title: '流向商业流向查询',
            name: 'distributorSalesFlowSimpleQuery',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/salesFlowQuery/distributorSalesFlowSimpleQuery.vue')
        },
        {
            path: 'distributorDailyStatusQuery',
            title: '流向商业日提供情况',
            name: 'distributorDailyStatusQuery',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/otherQuery/distributorDailyStatusQuery.vue')
        },
        {
            path: 'distributorMonthStatusQuery',
            title: '流向商业月提供情况',
            name: 'distributorMonthStatusQuery',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/otherQuery/distributorMonthStatusQuery.vue')
        },
        {
            path: 'delistingProductSalesFlowQuery',
            title: '退市产品流向查询',
            name: 'delistingProductSalesFlowQuery',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/salesFlowQuery/delistingProductSalesFlowQuery.vue')
        },
        {
            path: 'preparatorySalesFlowQuery',
            title: '可追溯商业流向查询',
            name: 'preparatorySalesFlowQuery',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/salesFlowQuery/preparatorySalesFlowQuery.vue')
        },
        {
            path: 'stimulantFeedBack',
            title: '兴奋剂反馈',
            name: 'stimulantFeedBack',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/salesFlowQuery/analepticQuery.vue')
        },
        {
            path: 'batchModification',
            title: '默认批号修改',
            name: 'batchModification',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/salesFlowQuery/batchModification.vue')
        },
        {
            path: 'dailyFlowQuery',
            title: '日流向查询',
            name: 'dailyFlowQuery',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/salesFlowQuery/dailyFlowQuery.vue')
        },
        {
            path: 'diurnalFlowByTerminal',
            title: '日流向 By Terminal',
            name: 'diurnalFlowByTerminal',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/salesFlowQuery/diurnalFlowByTerminal.vue')
        },
        {
            path: 'monthlyFlowByTerminal',
            title: '月流向 By Terminal',
            name: 'monthlyFlowByTerminal',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/salesFlowQuery/monthlyFlowByTerminal.vue')
        },
        //  流向核查
        {
            path: 'salesflowDeficiencyInspect',
            title: '流向差异性核查',
            name: 'salesflowDeficiencyInspect',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/salesFlowInspect/salesflowDeficiencyInspect.vue')
        },
        {
            path: 'channelAbnormalFeedBack',
            title: '渠道反馈',
            name: 'channelAbnormalFeedBack',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/salesFlowInspect/channelAbnormalInspect.vue')
        },
        {
            path: 'channelAbnormalReason',
            title: '其他渠道记录', // '渠道异常反馈记录',
            name: 'channelAbnormalReason',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/salesFlowInspect/channelAbnormalReason.vue')
        },
        {
            path: 'suspectAllocation',
            title: '疑似调拨',
            name: 'suspectAllocation',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/salesFlowInspect/suspectAllocation.vue')
        },
        {
            path: 'targetHospitalSales',
            title: '目标医院预警',
            name: 'targetHospitalSales',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/salesFlowInspect/targetHospitalSales.vue')
        },
        // 数据删除
        {
            path: 'deleteDailyStatus',
            title: '删除日数据提供情况',
            name: 'deleteDailyStatus',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/deleteData/deleteDailyStatus.vue')
        },
        {
            path: 'deleteMonthlyPurchase',
            title: '删除月采购数据',
            name: 'deleteMonthlyPurchase',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/deleteData/deleteMonthlyPurchase.vue')
        },
        {
            path: 'deleteDailyPurchase',
            title: '删除日采购数据',
            name: 'deleteDailyPurchase',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/deleteData/deleteDailyPurchase.vue')
        },
        {
            path: 'deleteDailyStock',
            title: '删除日库存',
            name: 'deleteDailyStock',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/deleteData/deleteDailyStock.vue')
        },
        {
            path: 'deleteDailySalesFlow',
            title: '删除日流向',
            name: 'deleteDailySalesFlow',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/deleteData/deleteDailySalesFlow.vue')
        },
        {
            path: 'salesReturnOwner',
            title: '销退主导人',
            name: 'salesReturnOwner',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/salesReturn/salesReturnOwner.vue')
        },
        {
            path: 'salesReturnReason',
            title: '销退原因',
            name: 'salesReturnReason',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/salesReturn/salesReturnReason.vue')
        },
        {
            path: 'salesReturnReport',
            title: '销退报表',
            name: 'salesReturnReport',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/salesReturn/salesReturnReport.vue')
        },
        {
            path: 'salesReturnReply',
            title: '销退反馈',
            name: 'salesReturnReply',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/salesReturn/salesReturnReply.vue')
        },
        {
            path: 'dailySummaryReport',
            title: '每日汇总报告',
            name: 'dailySummaryReport',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/salesFlowQuery/dailySalesFlowSummary.vue')
        },
        {
            path: 'dtpDataQuery',
            title: 'DTP数据查询',
            name: 'dtpDataQuery',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/dtpDataManagement/dtpDataQuery.vue')
        },
        {
            path: 'dtpDataImport',
            title: 'DTP数据导入',
            name: 'dtpDataImport',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/dtpDataManagement/dtpDataImport.vue')
        },
        {
            path: 'dtpDataImportLog',
            title: 'DTP上传日志',
            name: 'dtpDataImportLog',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/dtpDataManagement/dtpDataImportLog.vue')
        }
    ]
},
{
    path: '/inventory',
    name: 'inventory',
    title: '进销存管理',
    component: Main,
    children: [
        // 进销存报告
        {
            path: 'inventoryList',
            title: '进销存管理',
            name: 'inventoryList',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/inventory/inventoryManagement/inventoryList.vue')
        },
        {
            path: 'inventoryGenerate',
            title: '计算报告',
            name: 'inventoryGenerate',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/inventory/inventoryManagement/inventoryGenerate.vue')
        },
        // 库存天数计算
        {
            path: 'distributorInventoryDay',
            title: '流向商业库存天数',
            name: 'distributorInventoryDay',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/inventory/inventoryDaysCalculation/distributorInventoryDay.vue')
        },
        {
            path: 'productInventoryDay',
            title: '产品库存天数',
            name: 'productInventoryDay',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/inventory/inventoryDaysCalculation/productInventoryDay.vue')
        },
        {
            path: 'inventoryEstimateMonth',
            title: '当月库存预估',
            name: 'inventoryEstimateMonth',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/inventory/inventoryDaysCalculation/inventoryEstimateMonth.vue')
        },
        // 进销存核查
        {
            path: 'monthlySalesFlowInspect',
            title: '月进销差异核查',
            name: 'monthlySalesFlowInspect',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/inventory/inventoryInspect/monthlySalesFlowInspect.vue')
        },
        {
            path: 'dailyInventoryFeedBack',
            title: '日库存差异反馈',
            name: 'dailyInventoryFeedBack',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/inventory/inventoryInspect/dailyInventoryInspect.vue')
        },
        // 进销存报表
        {
            path: 'otherItemReport',
            title: '进销存其它项汇总',
            name: 'otherItemReport',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/inventory/inventoryReport/otherItemReport.vue')
        },
        {
            path: 'distributorProductReport',
            title: '按产品经销商统计',
            name: 'distributorProductReport',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/inventory/inventoryReport/distributorProductReport.vue')
        },
        {
            path: 'distributorAmountReport',
            title: '流向商业库存金额',
            name: 'distributorAmountReport',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/inventory/inventoryReport/distributorAmountReport.vue')
        },
        {
            path: 'negativeStockFeedBack',
            title: '负库存反馈',
            name: 'negativeStockFeedBack',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/inventory/inventoryReport/flowNegativeStock.vue')
        },
        {
            path: 'batchMonthlyInventory',
            title: '批号月库存查询',
            name: 'batchMonthlyInventory',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/inventory/inventoryReport/batchMonthlyInventory.vue')
        },
        {
            path: 'inventoryOverview',
            title: 'T1进销存进展',
            name: 'inventoryOverview',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/inventory/inventoryReport/inventoryOverview.vue')
        },
        {
            path: 'inventoryUpdateReport',
            title: '进销存更新报告',
            name: 'inventoryUpdateReport',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/inventory/inventoryReport/inventoryUpdateReport.vue')
        },
        // 日库存
        {
            path: 'dailyInventoryList',
            title: '日库存查询',
            name: 'dailyInventoryList',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/inventory/dailyInventory/dailyInventoryList.vue')
        }
    ]
},
{
    path: '/order',
    name: 'order',
    title: '订单管理',
    component: Main,
    children: [
        // 协议管理
        {
            path: 'shipper',
            title: '货主管理',
            name: 'shipper',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/order/agreementManagement/shipper.vue')
        },
        {
            path: 'warehouse',
            title: '库房管理',
            name: 'warehouse',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/order/agreementManagement/warehouse.vue')
        },
        {
            path: 'shipperWarehouseProduct',
            title: '货主产品库房关联',
            name: 'shipperWarehouseProduct',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/order/agreementManagement/shipperWarehouseProduct.vue')
        },
        {
            path: 'customerAgreement',
            title: '协议维护',
            name: 'customerAgreement',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/order/agreementManagement/customerAgreement.vue')
        },
        {
            path: 'priceAgreement',
            title: '产品价格维护',
            name: 'priceAgreement',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/order/agreementManagement/priceAgreement.vue')
        },
        {
            path: 'agreementNoticeList',
            title: '通知协议管理',
            name: 'agreementNoticeList',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/order/agreementManagement/agreementNoticeList.vue')
        },
        {
            path: 'agreementNoticeDetailList',
            title: '通知协议明细查询',
            name: 'agreementNoticeDetailList',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/order/agreementManagement/agreementNoticeDetailList.vue')
        },
        {
            path: 'credit',
            title: 'GXP商业资信维护',
            name: 'credit',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/order/agreementManagement/credit.vue')
        },
        // 订单管理
        {
            path: 'orderProcessing',
            title: '订单处理',
            name: 'orderProcessing',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/order/orderManagement/orderProcessing.vue')
        },
        {
            path: 'orderManagement',
            title: '订单流程',
            name: 'orderManagement',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/order/orderManagement/orderManagement.vue')
        },
        {
            path: 'scanBarcode',
            title: '合同扫描确认',
            name: 'scanBarcode',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/order/orderManagement/scanBarcode.vue')
        },
        {
            path: 'orderDetail',
            title: '订单明细查询',
            name: 'orderDetail',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/order/orderManagement/orderDetailQuery.vue')
        },
        {
            path: 'bill',
            title: 'GXP账单信息维护',
            name: 'bill',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/order/orderManagement/bill.vue')
        },
        {
            path: 'paymentBankAnotherName',
            title: '回款别名查询',
            name: 'paymentBankAnotherName',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/order/paymentCollection/paymentBankAnotherName.vue')
        },
        {
            path: 'paymentBank',
            title: '回款信息查询',
            name: 'paymentBank',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/order/paymentCollection/paymentBank.vue')
        },
        {
            path: 'deliveryDetail',
            title: '物流明细',
            name: 'deliveryDetail',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/order/deliveryManagement/deliveryDetail.vue')
        },
        {
            path: 'shippingCalendar',
            title: 'Shipping Calendar',
            name: 'shippingCalendar',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/order/deliveryManagement/shippingCalendar.vue')
        },
        {
            path: 'partnerProductManagement',
            title: '合作方客户产品关联',
            name: 'partnerProductManagement',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/order/partnerManagement/partnerProductManagement.vue')
        },
        {
            path: 'partnerOrderManagement',
            title: '合作方订单查询',
            name: 'partnerOrderManagement',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/order/partnerManagement/partnerOrderManagement.vue')
        },
        {
            path: 'partnerBillManagement',
            title: '合作方账单查询',
            name: 'partnerBillManagement',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/order/partnerManagement/partnerBillManagement.vue')
        },
    ]
},
{
    path: '/salePlan',
    name: 'salePlan',
    title: '销售计划',
    component: Main,
    children: [
        // 销售管理
        {
            path: 'importSalesPlan',
            title: '销售计划导入',
            name: 'salesPlanManagement',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salePlan/salesPlanManagement/importSalesPlan.vue')
        },
        {
            path: 'salesPlanKPI',
            title: '销售计划KPI',
            name: 'salesPlanKPI',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salePlan/salesPlanManagement/salesPlanKPI.vue')
        },
        {
            path: 'KPISummary',
            title: 'KPI汇总',
            name: 'KPISummary',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salePlan/salesPlanManagement/KPISummary.vue')
        },
        {
            path: 'inventorydaysmaintenance',
            title: '库存天数基础数据维护',
            name: 'inventorydaysmaintenance',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salePlan/salesPlanManagement/inventorydaysmaintenance.vue')
        },
        {
            path: 'salescoefficientmaintenance',
            title: '销量系数维护',
            name: 'salescoefficientmaintenance',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salePlan/salesPlanManagement/salescoefficientmaintenance.vue')
        },
        {
            path: 'overallSalesPlan',
            title: '总发货计划维护',
            name: 'overallSalesPlan',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salePlan/salesPlanManagement/overallSalesPlan.vue')
        },
        // 销售计划报表
        {
            path: 'achievingRateReport',
            title: '销售计划完成率报表',
            name: 'achievingRateReport',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salePlan/salesPlanReport/achievingRateReport.vue')
        },
        // 销售计划分货报表
        {
            path: 'salesPlanDistributionReport',
            title: 'Proposal Simulator',
            name: 'salesPlanDistributionReport',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salePlan/salesPlanReport/salesPlanDistributionReport.vue')
        }
    ]
},
{
    path: '/report',
    name: 'report',
    title: '数据报表',
    component: Main,
    children: [
        // 流向报表
        {
            path: 'analysisByReceiverProvince',
            title: '按收货方省份汇总',
            name: 'analysisByReceiverProvince',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/report/salesFlow/analysisByReceiverProvince.vue')
        },
        {
            path: 'analysisByReceiver',
            title: '按收货方汇总',
            name: 'analysisByReceiver',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/report/salesFlow/analysisByReceiver.vue')
        },
        {
            path: 'analysisInMarket',
            title: '月度TMS报表',
            name: 'analysisInMarket',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/report/salesFlow/analysisInMarket.vue')
        },
        {
            path: 'analysisInByDistributor',
            title: '按发货方汇总',
            name: 'analysisInByDistributor',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/report/salesFlow/analysisInByDistributor.vue')
        },
        {
            path: 'analysisByDistributorAndReceiver',
            title: '发货方收货方汇总',
            name: 'analysisByDistributorAndReceiver',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/report/salesFlow/analysisByDistributorAndReceiver.vue')
        },
        {
            path: 'compareByDistributor',
            title: '发货方对比报表',
            name: 'compareByDistributor',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/report/salesFlow/compareByDistributor.vue')
        },
        {
            path: 'compareByReceiver',
            title: '收货方对比报表',
            name: 'compareByReceiver',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/report/salesFlow/compareByReceiver.vue')
        },
        {
            path: 'splitDetailQuery',
            title: '拆分查询报表',
            name: 'splitDetailQuery',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/report/salesFlow/splitDetailQuery.vue')
        },
        {
            path: 'dailySalesflowDifferenceReport',
            title: '日数据预警报表',
            name: 'dailySalesflowDifferenceReport',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/report/salesFlow/dailySalesflowDifferenceReport.vue')
        },
        {
            path: 'monthlyTMSByProvince',
            title: '月度TM按省份汇总',
            name: 'monthlyTMSByProvince',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/salesFlow/report/salesFlow/monthlyTMSByProvince.vue')
        }
    ]
},
{
    path: '/bidding',
    name: 'bidding',
    title: '招标管理',
    component: Main,
    children: [{
        path: 'biddingProject',
        title: '项目管理',
        name: 'biddingProject',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/bidding/biddingProject.vue')
    },
    {
        path: 'tenderPriceQuery',
        title: '价格查询',
        name: 'tenderPriceQuery',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/bidding/tenderPriceQuery.vue')
    },
    {
        path: 'biddingDetailQuery',
        title: '明细查询',
        name: 'biddingDetailQuery',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/bidding/biddingDetailQuery.vue')
    },
    {
        path: 'biddingMonthRealPrice',
        title: '月度实际采购价',
        name: 'biddingMonthRealPrice',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/bidding/report/biddingMonthRealPrice.vue')
    },
    {
        path: 'biddingQueryForRepresentative',
        title: '外勤项目维护',
        name: 'biddingQueryForRepresentative',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/bidding/biddingQueryForRepresentative.vue')
    },
    {
        path: 'theLowestBidPrice',
        title: '全国省级最低中标价',
        name: 'theLowestBidPrice',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/bidding/report/theLowestBidPrice.vue')
    },
    {
        path: 'biddingPriceConflict',
        title: '价格验证报表',
        name: 'biddingPriceConflict',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/bidding/report/biddingPriceConflict.vue')
    },
    {
        path: 'biddingOfDelistingProducts',
        title: '退市产品招标报表',
        name: 'biddingOfDelistingProducts',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/bidding/report/biddingOfDelistingProducts.vue')
    },
    {
        path: 'defaultBidder',
        title: '默认投标主体管理',
        name: 'defaultBidder',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/bidding/biddingSetting/defaultBidder.vue')
    },
    {
        path: 'biddingStep',
        title: '流程步骤管理',
        name: 'biddingStep',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/bidding/biddingSetting/biddingStep.vue')
    },
    {
        path: 'biddingType',
        title: '招标类型管理',
        name: 'biddingType',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/bidding/biddingSetting/biddingType.vue')
    },
    {
        path: 'militaryRegionManagement',
        title: '军区管理',
        name: 'militaryRegionManagement',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/system/biddingSetting/militaryRegionManagement.vue')
    }
    ]
},
{
    path: '/compensation',
    name: 'compensation',
    title: '招标补偿',
    component: Main,
    children: [{
        path: 'compensationSummaryList',
        title: '补偿单价管理',
        name: 'compensationSummaryList',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/compensation/compensationSummaryList.vue')
    },
    {
        path: 'drugStoreSetting',
        title: '药店补偿名单管理',
        name: 'drugStoreSetting',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/compensation/drugStoreSetting.vue')
    },
    {
        path: 'drugStoreCompensationFile',
        title: '药店补偿支持件',
        name: 'drugStoreCompensationFile',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/compensation/drugStoreCompensationFile.vue')
    },
    {
        path: 'confirmUnitPriceDetail',
        title: '确认补偿单价',
        name: 'confirmUnitPriceDetail',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/compensation/confirmUnitPriceDetail.vue')
    },
    {
        path: 'certificateManagement',
        title: '补偿证明管理',
        name: 'certificateManagement',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/compensation/certificate/certificateManagement.vue')
    },
    {
        path: 'returnRequirement',
        title: '退货证明需求',
        name: 'returnRequirement',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/compensation/certificate/returnRequirement.vue')
    },
    {
        path: 'certificateQuery',
        title: '补偿证明查询',
        name: 'certificateQuery',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/compensation/certificate/certificateQuery.vue')
    },
    {
        path: 'certificateDetailForRepresentative',
        title: '付款渠道查询',
        name: 'certificateDetailForRepresentative',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/compensation/certificate/certificateDetailForRepresentative.vue')
    },
    {
        path: 'quarterCompensation',
        title: '季度补偿计算',
        name: 'quarterCompensation',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/compensation/quarterCompensationList.vue')
    },
    {
        path: 'accruedExpense',
        title: '月度预提',
        name: 'accruedExpense',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/compensation/accruedExpenseList.vue')
    },
    {
        path: 'dwCompensationList',
        title: 'D&W补偿名单管理',
        name: 'dwCompensationList',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/compensation/dwCompensationSetting.vue')
    },
    {
        path: 'dwCompensationCoefficientList',
        title: 'D&W补偿系数管理',
        name: 'dwCompensationCoefficientList',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/compensation/dwCompensationCoefficientSetting.vue')
    },
    {
        path: 'shippingModeManagement',
        title: '发货模式维护',
        name: 'shippingModeManagement',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/compensation/shippingModeManagement.vue')
    },
    {
        path: 'discountCategoryMaintenance',
        title: '折让分类维护',
        name: 'discountCategoryMaintenance',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/compensation/discountCategoryMaintenance.vue')
    },
    {
        path: 'materialgroupcoefficient',
        title: 'VAT及补偿系数维护',
        name: 'materialgroupcoefficient',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/compensation/materialgroupcoefficient.vue')
    },
    {
        path: 'materialgroupconversion',
        title: '分型间折算维护',
        name: 'materialgroupconversion',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/compensation/materialgroupconversion.vue')
    },
    {
        path: 'simpleExpropriation',
        title: '简易征收补偿单价',
        name: 'simpleExpropriation',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/compensation/simpleExpropriation.vue')
    },
    {
        path: 'commissionedImport',
        title: '委托进口折让单价',
        name: 'commissionedImport',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/compensation/commissionedImport.vue')
    },
    {
        path: 'quarterCommissionedImport',
        title: '季度委托进口折让单价',
        name: 'quarterCommissionedImport',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/compensation/quarterCommissionedImport.vue')
    },
    {
        path: 'commissionedImportRule',
        title: '季度委托进口折让单价',
        name: 'commissionedImportRule',
        meta: {
            requireAuth: true
        },
        icon: 'compose',
        component: () =>
            import('@/views/compensation/commissionedImportRule.vue')
    },
    ]
},
{
    path: '/visit',
    name: 'visit',
    title: '药店质量检查',
    component: Main,
    children: [

        {
            path: 'visitPlan',
            title: '检查计划',
            name: 'visitPlan',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/visit/visitPlanList.vue')
        },
        {
            path: 'drugstoreManagement',
            title: '药店基础数据',
            name: 'drugstoreManagement',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/visit/drugstoreManagement.vue')
        },
        {
            path: 'drugstoreBUManagement',
            title: 'BU与药店基础数据',
            name: 'drugstoreBUManagement',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/visit/drugstoreBUManagement.vue')
        },
        {
            path: 'visitResult',
            title: '检查结果',
            name: 'visitResult',
            meta: {
                requireAuth: true
            },
            icon: 'compose',
            component: () =>
                import('@/views/visit/visitResultList.vue')
        }
    ]
}
]
export const routers = [
    loginRouter,
    ...appRouter,
    page403,
    page404,
    page500,
    loginJump
]



// WEBPACK FOOTER //
// ./src/router/router.js